export default __webpack_public_path__ + "static/media/arrow-right-grey.0d0495d7.svg";